import { List, Tab, TabBar, Tabs, TabView } from '@salecycle/ui-component-library';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useAccessLevel } from 'core/app/AppContext';
import { IRecentClient } from '../types/recentClients';
import RecentClientListItem from './RecentClientListItem';

interface IRecentClientsProps {
  clients: IRecentClient[];
}

const RecentClients: FC<IRecentClientsProps> = props => {
  const { t } = useTranslation();
  const { accessLevel } = useAccessLevel();

  return (
    <Tabs fillHeight={true}>
      <TabBar>
        <Tab tabId="recent-clients">
          {t('client.search.recent.heading', {
            context: accessLevel === 'MultiSite' ? 'multisite' : null,
          })}
        </Tab>
      </TabBar>
      <TabView padding={0}>
        <List>
          {props.clients.reverse().map((client: IRecentClient, index: number) => (
            <RecentClientListItem key={index} recentClient={client} />
          ))}
        </List>
      </TabView>
    </Tabs>
  );
};

export default RecentClients;
